import styled from 'styled-components';

const ContainerStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 20px 0;
  background: rgba(255, 255, 255, 0.95);
  boxshadow: 0px 9px 38px -6px rgba(0, 0, 0, 0.14);

  @media (min-width: 769px) {
    padding: 48px 20px;
  }
`;

const ParagraphStyled = styled.p`
  font-family: cerapro;
  font-size: 16px;
  text-align: center;
  color: #2d1441;
  padding: 24px 20px 32px;
  max-width: 590px;
`;

const NewParagraphStyled = styled.p`
  font-family: cerapro;
  font-size: 16px;
  text-align: center;
  color: #21102e;
  max-width: 590px;
  margin: 24px 0px 0px;
`;

const NewParagraphStrongStyled = styled.p`
  font-family: cerapro;
  font-size: 16px;
  text-align: center;
  font-weight: 700;
  color: #21102e;
  max-width: 590px;
  margin: 0px 0px 32px;
`;

export {
  ContainerStyled,
  ParagraphStyled,
  NewParagraphStyled,
  NewParagraphStrongStyled,
};
